import Component from './new-pass'

export default Component